<aumico-user-security-page></aumico-user-security-page>
<ng-template #footerTemplate> </ng-template>
